import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-volunteer',
  imports: [],
  templateUrl: './volunteer.component.html',
  styleUrl: './volunteer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VolunteerComponent {

}
